module.exports = "<div class=commits-list> <p>This is an automated file created by running <code>make changelog</code>.</p> </div> ";